<template>
  <zh-table-page
    ref="tableRef"
    v-bind="{
      title: '消息服务',
      search,
      api,
      afterGetDetail,
      beforeSave,
      ...table,
      ...dialog,
    }"
  >
  </zh-table-page>

</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  getCurrentInstance,
  onMounted,
  watch,
  computed,
} from "vue";
import { useRouter } from "vue-router";
import { ElMessageBox } from "element-plus";
import moment from "moment"
export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const tableRef = ref();
    const state = reactive({
      search: [
        {
          label: "服务名称",
          placeholder: "服务名称",
          value: "serviceName",
        },
        // {
        //   component: "zh-select",
        //   label: "服务器",
        //   placeholder: "服务器",
        //   value: "serverId",
        //   url:"postServerList",
        //     field: {
        //       id: "value",
        //       serverName: "label",
        //     },
         
        // },
      ],
      api: {
        list: "postServicePage",
        delete: "deleteServiceDelete",
        add: "postServiceSave",
        edit: "postServiceUpdate",
        detail: "",
        tree: "",
      },
      table: {
        columns: [
          { label: "服务名称", prop: "serviceName" },
          { label: "服务负责人", prop: "head" },
          { label: "服务所属部门", prop: "development" },

        ],
        operations: [
          { label: "编辑" },
          { label: "删除", type: "danger" },
        ],
        rowKey: "id",
      },
      dialog: {
        dialogForm: [
          {
            label: "服务名称",
            placeholder: "请输入服务名称",
            value: "serviceName",
          },
          {
            label: "服务负责人",
            placeholder: "请输入服务负责人",
            value: "head",
          },
          {
            label: "服务所属部门",
            placeholder: "请输入服务所属部门",
            value: "development",
          },
         
        ],
        dialogRules: {
          serviceName: [
            { required: true, message: "服务名称不能为空", trigger: "blur" },
          ],
          head: [
            { required: true, message: "服务负责人不能为空", trigger: "blur" },
          ],
          development: [
            { required: true, message: "服务所属部门不能为空", trigger: "blur" },
          ],
         
         
        },
      },
    });
    onMounted(() => {
    });
    //点击编辑处理详情数据
    const afterGetDetail = (data) => {
      return {
        ...data,
       
      };
    };
    //新增编辑保存之前
    const beforeSave = (form)=>{
      return {
        ...form,
      }
    }

    return {
      ...toRefs(state),
      tableRef,
      afterGetDetail,
      beforeSave,
    };
  },
});
</script>
